import { useLocation } from 'react-router-dom';
import { IMG_URL } from '../../../store/Apis';
import styles from './CustomerDetail.module.css';
import dummyImg from "../../../assets/dummy.png";
import moment from 'moment';
import { useTranslation } from 'react-i18next';

const CustomerDetail = () => {
    const phoneFormat = (text) => {

        var cleaned = ("" + text).replace(/\D/g, "");
        var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

        if (match) {
            var intlCode = match[1] ? "+1 " : "",
                number = [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join(
                    ""
                );
            return number;
        }
        return text;
    }
    const { t } = useTranslation();
    const { state } = useLocation();
    console.log('stateeee', state);
    return (
        <div className={styles.mainDiv}>
            <div className={styles.heading}>
                <h1>{t("Customer")}</h1>
            </div>
            <div className={styles.detailDiv}>
                <div className={styles.header}>
                    <div className={styles.headerImg}>
                        <img src={state?.profile_image ? IMG_URL + state?.profile_image : dummyImg} />
                    </div>
                    <div className={styles.headerContent}>
                        <h1>{state?.name}</h1>
                        <p>Customer</p>
                        {/* <p>{state?.designation}</p> */}
                    </div>
                </div>
                <div className={styles.basicInfoDiv}>
                    <h1>{t("Basic Information")}</h1>
                    <div className={styles.row}>
                        <div className={styles.colLeft}>
                            <span>{t("Email")}</span>
                            <p>{state?.email}</p>
                        </div>
                        <div className={styles.colRight}>
                            <span>{t("Contact Number")}</span>
                            <p>{phoneFormat(state?.contact_no)}</p>
                        </div>

                    </div>
                    <div className={styles.row}>
                        {state?.working_start_time ?
                            <div className={styles.colLeft}>
                                <span>{t("Work Hours")}</span>
                                <p>{moment('01 jan 1947 ' + state?.working_start_time).format('hh:mm A') + ' to ' + moment('01 jan 1947 ' + state?.working_end_time).format('hh:mm A')}</p>
                            </div>
                            : null}
                        {/* <div className={styles.colRight}>
                            {state?.addresses?.length ? state?.addresses?.map((item, index) => {
                                return (
                                    <>
                                        <span>{t("Address")} {index + 1}</span>
                                        <p>{item?.address}</p>
                                    </>
                                )
                            }) : null}
                            {state?.address?.length ? state?.address?.map((item, index) => {
                                return (
                                    <>
                                        <span>{t("Address")} {index + 1}</span>
                                        <p>{item?.address}</p>
                                    </>
                                )
                            }) : null}

                        </div> */}
                        {/* <div className={styles.colRight}>
                        <span>Address 2</span>
                            <p>Street : 854 Avocado Ave Xyz Road , Ny USA</p>
                        </div> */}
                    </div>
                    <h1>{t("Company Details")}</h1>
                    <div className={styles.row}>
                        <div className={styles.colLeft}>
                            <span>{t("Company Name")}</span>
                            <p>{state?.company?.name}</p>
                        </div>
                        <div className={styles.colRight}>
                            <span>{t("Company Address")}</span>
                            <p>{state?.company?.address}</p>
                        </div>

                    </div>
                    <div className={styles.row}>
                        <div className={styles.colLeft}>
                            <span>{t("Company Number")}</span>
                            <p>{phoneFormat(state?.company?.contact_no)}</p>
                        </div>
                        <div className={styles.colRight}>
                            <span>{t("Company Website")}</span>
                            <a href={state?.company?.website} target='blank'> <p>{state?.company?.website}</p></a>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}
export default CustomerDetail;